import React from 'react'
import Layout from '../../components/layout/Layout'
import { collectionCreditos } from '../../directories/creditos'

const CreditosView = () => {
    return (
        <Layout>
            <div className='grid_creditos'>
                {
                    collectionCreditos.map(dato => (
                        <div className='item_creditos' key={dato.id}>
                            <figure>
                                <img src={dato.img} alt='Foto' />
                            </figure>
                            <div className='datos'>
                                <article>
                                    <p>{dato.autor}</p>
                                    <p>{dato.description}</p>
                                    <p><span>{dato.link}</span></p>
                                </article>
                            </div>
                        </div>
                    ))
                }
            </div>
        </Layout>
    )
}

export default CreditosView
